import { BookOpen, ShieldCheck, Users, BarChart3 } from "lucide-react";

const services = [
  {
    icon: BookOpen,
    title: "Bookkeeping",
    desc: "Day-to-day record-keeping done right. We manage transactions, reconcile accounts, track expenses and keep everything accurate so you always know where your business stands.",
    span: "lg:col-span-2",
    dark: true,
  },
  {
    icon: ShieldCheck,
    title: "GST & PAYE Compliance",
    desc: "Stay fully compliant with GST, PAYE and all IRD requirements. We prepare and file returns, manage deadlines and keep you clear of penalties.",
    span: "",
    dark: false,
  },
  {
    icon: Users,
    title: "Payroll",
    desc: "Accurate, on-time pay runs — wages, PAYE, KiwiSaver, leave and payslips, all filed with IRD. Stress-free payroll for you and your team.",
    span: "",
    dark: false,
  },
  {
    icon: BarChart3,
    title: "Financial Reporting",
    desc: "Clear, easy-to-read Profit & Loss, Balance Sheet and cashflow reports that help you understand performance and make confident decisions.",
    span: "lg:col-span-2",
    dark: true,
  },
];

function ServiceCard({ service, index }) {
  const { icon: Icon, title, desc, span, dark } = service;
  return (
    <div
      data-testid={`service-card-${index}`}
      className={`offset-hover fade-up rounded-md p-8 ${span} ${
        dark
          ? "bg-[#10242B] text-white"
          : "bg-white border border-[#E1E8E9] text-[#10242B]"
      }`}
      style={{ animationDelay: `${0.08 * index}s` }}
    >
      <div
        className={`inline-flex h-12 w-12 items-center justify-center rounded-md mb-6 ${
          dark ? "bg-[#10BFCB]" : "bg-[#10242B]"
        }`}
      >
        <Icon size={24} className={dark ? "text-[#10242B]" : "text-[#10BFCB]"} />
      </div>
      <h3 className="font-heading text-2xl font-medium mb-3">{title}</h3>
      <p className={`leading-relaxed ${dark ? "text-white/80" : "text-[#55636B]"}`}>
        {desc}
      </p>
    </div>
  );
}

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <h4 className="text-sm font-semibold uppercase tracking-[0.15em] text-[#0DA2AD]">
            Our Services
          </h4>
          <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-[#10242B]">
            Everything your books need, in one place
          </h2>
          <p className="mt-5 text-lg text-[#55636B]">
            Reliable, professional support tailored to your business — so your
            financial data is organised, compliant and ready whenever you need it.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <ServiceCard key={s.title} service={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
